<template>
  <!-- User Profile Preference Edit Info Tab Content View From Account Profile -->
  <div>
    <div class="tabs-content-secondblock mb-7">
      <div class="row" v-if="ajaxCallinprogress">
        <div class="col-lg-12 py-5 px-3 mt-10">
          <div class="flex-container">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
          </div>
        </div>
      </div>
      <div class="row" v-if="!ajaxCallinprogress">
        <div class="col-lg-12">
          <div class="ml-2 mr-1">
            <div class="row">
              <div class="col-lg-12">
                <div class="infoHeader mt-4 pb-4">
                  <h6 class="subHeaderTitle ml-4">Food Preferences</h6>
                  <div class="a-q-Jc-j-editcontactView mt-1">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Favorite Food</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView font-color">
                          <!-- <el-tooltip class="item" effect="light" :content="editPreferenceData.preferences.value.food_preferences.favourite_food" placement="top"> -->
                            <input
                              class="inputField"
                              type="text"
                              v-model="editPreferenceData.preferences.value.food_preferences.favourite_food"
                              :maxlength="maxlengthaccountfavfood"
                              name="favourite_food"
                              placeholder="Enter Favourite Food"
                              style="padding: 15px 60px 5px 0px !important;"
                            />
                          <!-- </el-tooltip> -->
                          <span
                            class="editcharacter-count text-grey"
                            style="margin-top: -20px;"
                          >{{maxlengthaccountfavfood - editPreferenceData.preferences.value.food_preferences.favourite_food.length}}/100</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView mt-1">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Favorite Drink</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView font-color">
                          <!-- <el-tooltip class="item" effect="light" :content="editPreferenceData.preferences.value.food_preferences.favourite_drink" placement="top"> -->
                            <input
                              class="inputField"
                              type="text"
                              v-model="editPreferenceData.preferences.value.food_preferences.favourite_drink"
                              :maxlength="maxlengthaccountfavdrink"
                              name="favourite_drink"
                              placeholder="Enter Favourite Drink"
                              style="padding: 15px 60px 5px 0px !important;"
                            />
                          <!-- </el-tooltip> -->
                          <span
                            class="editcharacter-count text-grey"
                            style="margin-top: -20px;"
                          >{{maxlengthaccountfavdrink - editPreferenceData.preferences.value.food_preferences.favourite_drink.length}}/100</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Food Allergy</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView text-runcate">
                          <!-- <el-tooltip class="item" effect="light" :content="editPreferenceData.preferences.value.food_preferences.food_allergy" placement="top"> -->
                            <input
                              class="inputField"
                              type="text"
                              v-model="editPreferenceData.preferences.value.food_preferences.food_allergy"
                              :maxlength="maxlengthaccountfoodallergy"
                              name="food_allergy"
                              placeholder="Enter Food Allergy"
                              style="padding: 15px 60px 5px 0px !important;"
                            />
                          <!-- </el-tooltip> -->
                          <span
                            class="editcharacter-count text-grey"
                            style="margin-top: -20px;"
                          >{{maxlengthaccountfoodallergy - editPreferenceData.preferences.value.food_preferences.food_allergy.length}}/100</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="infoHeader mt-4 pb-4">
                  <h6 class="subHeaderTitle ml-4">
                    Dietary Preferences
                    <sup class="fs-14 ml-1 mandatory">
                      <el-tooltip
                        class="item"
                        effect="light"
                        content="The options for this field are configurable in the Settings page"
                        placement="right"
                      >
                        <i class="icon-information text-secondary" style="font-size: 14px"></i>
                      </el-tooltip>
                    </sup>
                    </h6>
                  <div class="a-q-Jc-j-editcontactView">
                    <div class="mt-3 mb-3 ml-4">
                      <label
                        class="custom-control custom-checkbox digi-checkbox diet-checkbox"
                        v-for="(dietary, index) in userDietaryPreference"
                        :key="index"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :value="dietary"
                          :checked="editPreferenceData.preferences.value.dietary_preferences && editPreferenceData.preferences.value.dietary_preferences.indexOf(dietary) != -1"
                          @click="addDietaryPreference(dietary)"
                        />
                        <span class="custom-control-indicator"></span>
                        <span class="form-check-description fw-600">{{ dietary }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="infoHeader mt-4 pb-4">
                  <h6 class="subHeaderTitle ml-4">
                    Room Preferences
                    <sup class="fs-14 ml-1 mandatory">
                      <el-tooltip
                        class="item"
                        effect="light"
                        content="The options for this field are configurable in the Settings page"
                        placement="right"
                      >
                        <i class="icon-information text-secondary" style="font-size: 14px"></i>
                      </el-tooltip>
                    </sup>
                    </h6>
                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Room Type</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView">
                          <v-select
                            class="vselect-custom vselect-roomtype"
                            v-model="editPreferenceData.preferences.value.room_preferences.room_type"
                            placeholder="Select Room Type"
                            :options="['Single', 'Double', 'Triple', 'Quad', 'Queen', 'King', 'Twin', 'Double-double', 'Studio']"
                            style="width: 100%;"
                          ></v-select>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Pillow Type</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView">
                          <v-select
                            class="vselect-custom vselect-bloodgroup"
                            v-model="editPreferenceData.preferences.value.room_preferences.pillow_type"
                            placeholder="Select Pillow Type"
                            :options="['Hard', 'Medium', 'Soft']"
                            style="width: 100%;"
                          ></v-select>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Bed Type</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView">
                          <v-select
                            class="vselect-custom vselect-bloodgroup"
                            v-model="editPreferenceData.preferences.value.room_preferences.bed_type"
                            placeholder="Select Bed Type"
                            :options="['Hard', 'Medium', 'Soft']"
                            style="width: 100%;"
                          ></v-select>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3">Bedsheet Type</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView">
                          <v-select
                            class="vselect-custom vselect-bloodgroup"
                            v-model="editPreferenceData.preferences.value.room_preferences.bed_sheet_type"
                            placeholder="Select Bed Sheet Type"
                            :options="['Cotton', 'Wool']"
                            style="width: 100%;"
                          ></v-select>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { User } from "./mixins/user";
import VueTextareaAutosize from "vue-textarea-autosize";
import { HalfCircleSpinner } from "epic-spinners";
import { EventBus } from "./eventBus/nav-bar-event.js";
export default {
  data() {
    return {
      maxlengthaccountfoodallergy: 100,
      maxlengthaccountfavdrink: 100,
      maxlengthaccountfavfood: 100,
      editPreferenceData: {
        preferences: {
          value: {
            dietary_preferences: [],
            food_preferences: {
              favourite_drink: "",
              favourite_food: "",
              food_allergy: "",
            },
            room_preferences: {
              bed_sheet_type: "",
              bed_type: "",
              pillow_type: "",
              room_type: "",
            },
          },
          privacy: "contacts",
        },
      },
      ajaxCallinprogress: false,
      requestResponse: false,
      userBasicInfo: {},
    };
  },
  mixins: [User],
  methods: {
    // Adding editPersonalData empty array and updating user data
    updatePreference() {
      this.userBasicInfo.preferences.value = this.editPreferenceData.preferences.value;
      this.saveEditUser(this.userBasicInfo);
      this.$emit("updateUserData");
    },

    // Getting User Data
    async GetUserDetails(id) {
      this.ajaxCallinprogress = true;
      let res = await this.$http.post("/users/get_user_data", { user_id: id })
        if(res.data.status_id == 1) {
            this.userBasicInfo = res.data.response;
            if (!this.userBasicInfo.preferences) {
              this.userBasicInfo = {
                preferences: {
                  value: {
                    food_preferences: {
                      favourite_food: "",
                      favourite_drink: "",
                      food_allergy: "",
                    },
                    room_preferences: {
                      room_type: "",
                      bed_type: "",
                      pillow_type: "",
                      bed_sheet_type: "",
                    },
                    dietary_preferences: [],
                  },
                  privacy: "contacts",
                },
              };
            }
            if (this.userBasicInfo.preferences.value.dietary_preferences) {
              this.editPreferenceData.preferences.value.dietary_preferences = this.userBasicInfo.preferences.value.dietary_preferences;
              this.editPreferenceData.preferences.value.dietary_preferences.forEach((el,indexl)=>{
                this.editPreferenceData.preferences.value.dietary_preferences[indexl] = el.replace(/[\[\]']+/g, "")
              })
            }
            if (this.userBasicInfo.preferences.value.food_preferences) {
              this.editPreferenceData.preferences.value.food_preferences.favourite_drink = this.userBasicInfo.preferences.value.food_preferences.favourite_drink;
              this.editPreferenceData.preferences.value.food_preferences.favourite_food = this.userBasicInfo.preferences.value.food_preferences.favourite_food;
              this.editPreferenceData.preferences.value.food_preferences.food_allergy = this.userBasicInfo.preferences.value.food_preferences.food_allergy;
            }
            if (this.userBasicInfo.preferences.value.room_preferences) {
              this.editPreferenceData.preferences.value.room_preferences.bed_sheet_type = this.userBasicInfo.preferences.value.room_preferences.bed_sheet_type;
              this.editPreferenceData.preferences.value.room_preferences.bed_type = this.userBasicInfo.preferences.value.room_preferences.bed_type;
              this.editPreferenceData.preferences.value.room_preferences.pillow_type = this.userBasicInfo.preferences.value.room_preferences.pillow_type;
              this.editPreferenceData.preferences.value.room_preferences.room_type = this.userBasicInfo.preferences.value.room_preferences.room_type;
            }
            this.ajaxCallinprogress = false;
        }
      this.ajaxCallinprogress = false;
    },

    // Checkbox Functionality to add Dietary
    addDietaryPreference(value) {
      if (
        this.editPreferenceData.preferences.value.dietary_preferences.indexOf(
          value
        ) != -1
      ) {
        this.editPreferenceData.preferences.value.dietary_preferences.splice(
          this.editPreferenceData.preferences.value.dietary_preferences.indexOf(
            value
          ),
          1
        );
      } else {
        this.editPreferenceData.preferences.value.dietary_preferences.push(value);
      }
    },
  },
  //   props: ["userData"],
  components: {
    VueTextareaAutosize,
    HalfCircleSpinner,
  },
  mounted() {
    EventBus.$on("preferenceInformation", () => {
      this.updatePreference();
    });
    EventBus.$on("hideuser", () => {
      this.hideEdit();
    });
  },
  destroyed() {
    EventBus.$off("preferenceInformation");
    EventBus.$off("hideuser");
  },
  created() {
    if (this.$route.params.id) {
      this.GetUserDetails(this.$route.params.id);
    } else {
      this.GetUserDetails(this.loggedInUser._id);
    }
    this.GetDietaryPreference();
  },
  computed: {
    loggedInUser() {
      return this.$store.getters.loggedInUser;
    },
  },
};
</script>
<style>
.socialMedia.dropdown-toggle::after {
  margin-left: 5px;
}

@-moz-document url-prefix() {
  .inputMedia {
    padding-right: 26px !important;
  }
}
.mediaDropdown.dropdown-menu {
  margin: 0rem 0rem 0 !important;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-firstblock {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 5px 10px 15px;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-secondblock {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 5px 10px 15px;
}
textarea.textarea-control {
  height: auto;
}

textarea.textarea-control {
  display: block;
  width: 100%;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #4e5764;
  background-color: #fff;
  background-image: none;
  border: 1px solid #cdd2da;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
}
.input-group.digi-input-group {
  border: 1px solid #cdd2da !important;
}
.input-group.digi-input-group > .form-control {
  position: relative !important;
  -webkit-box-flex: 1 !important;
  -webkit-flex: 1 1 auto !important;
  -ms-flex: 1 1 auto !important;
  flex: 1 1 auto !important;
  width: 1% !important;
  margin-bottom: 0 !important;
  height: 22px !important;
  padding: 6px 12px 6px 2px !important;
  color: #4e5764;
  text-decoration: underline;
  border-bottom: 1px solid transparent !important;
}
.input-group.digi-input-group .input-group-addon {
  padding-left: 0rem !important;
  padding-right: 0.2rem !important;
  border-bottom: 1px solid transparent !important;
  padding-top: 2px;
  cursor: pointer;
}
.qrcode-block-view-account {
  border-radius: 6px;
  width: 104px;
  height: 105px;
  position: relative;
  display: inline-block;
  display: block;
  border: 1px solid #005dae;
  background: #d6e2ef;
}
.qrcode-content-view-account {
  text-align: center;
  margin: 6px auto;
  background: #d6e2ef !important;
}
.qr-logo-view-account {
  position: absolute;
  margin-top: 40px;
  margin-left: 35px;
  width: 30px;
}
.removeBlocks {
  right: 20px;
  margin-right: 2px;
}
.removeBlocksPhone {
  right: 18px;
  margin-right: 2px;
}
.removeBlocksPhone.removedAddPhone {
  right: 0px;
  margin-right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditPreferenceView.vue